import { render, staticRenderFns } from "./TeacherTabbar.vue?vue&type=template&id=d8f4c6fc&scoped=true&"
import script from "./TeacherTabbar.vue?vue&type=script&lang=js&"
export * from "./TeacherTabbar.vue?vue&type=script&lang=js&"
import style0 from "./TeacherTabbar.vue?vue&type=style&index=0&id=d8f4c6fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f4c6fc",
  null
  
)

export default component.exports